import { SendersI } from '../interfaces/senders.interface'
import { SendersService } from '../services/senders.service'
import {
    SenderPayloadT,
    SendersCreateSenderResponseT,
    SendersGetListResponseT,
    SendersSearchSenderResponseT,
} from '../types/senders.types'

const sendersService = new SendersService()

class SendersRealisation implements SendersI {
    getList(page: number, company_id: number, city_id?: number): Promise<SendersGetListResponseT> {
        return sendersService.getList(page, company_id, city_id)
    }

    createSender(payload: SenderPayloadT): Promise<SendersCreateSenderResponseT> {
        return sendersService.createSender(payload)
    }

    updateSender(id: number, payload: SenderPayloadT): Promise<SendersCreateSenderResponseT> {
        return sendersService.updateSender(id, payload)
    }

    updateSenderInOrder(id: number, payload: SenderPayloadT): Promise<void> {
        return sendersService.updateSenderInOrder(id, payload)
    }

    deleteSender(id: number): Promise<void> {
        return sendersService.deleteSender(id)
    }

    searchSender(
        param: string,
        company_id: number,
        exact_city_id?: number
    ): Promise<SendersSearchSenderResponseT> {
        return sendersService.searchSender(param, company_id, exact_city_id)
    }
}

export const senders = new SendersRealisation()
